module.exports = __webpack_public_path__ + "img/OKT.c6c33cac.png";